import React, { useState, useContext, useEffect } from "react";
import { Auth } from "aws-amplify";

const AuthContext = React.createContext();

const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    user: null,
    session: null,
  });

  useEffect(() => {
    initializeAuthState();
  }, []);

  async function initializeAuthState() {
    try {
      // Check if user exists in local storage
      const userExists = localStorage.getItem("user");
      if (!userExists) {
        console.log(
          "User not found in local storage. Clearing local storage..."
        );
        localStorage.clear();
        setAuthState({ isAuthenticated: false, user: null, session: null });
        return;
      }

      // Fetch authenticated user and session
      const currentUser = await Auth.currentAuthenticatedUser();
      const currentSession = await Auth.currentSession();

      setAuthState({
        isAuthenticated: true,
        user: currentUser,
        session: currentSession,
      });
    } catch (error) {
      console.error("Error initializing auth state:", error);
      localStorage.clear();
      setAuthState({ isAuthenticated: false, user: null, session: null });
    }
  }

  return (
    <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>
  );
};

function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined)
    throw new Error("AuthContext was used outside AuthProvider");
  return context;
}

export { AuthProvider, useAuth };
